<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-snackbar
            v-model="snackbar.show"
            :color=snackbar.color
            :top="true"
            :bottom="false"
            :left="false"
            :right="false"
            :multi-line="true"
            :timeout=snackbar.delay
            :vertical="false">
        {{ snackbar.text }}
        <v-btn
            text
            color=snackbar.buttonTextColor
            @click="HIDE_SNACKBAR()">Close</v-btn>
    </v-snackbar>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default
    {
        name: 'snackbar',
        computed: mapState({snackbar: state => state.common.snackbar}),
        methods: mapMutations('common', ['HIDE_SNACKBAR'])
    }
</script>